import { removableMarkers, type RemovableMarkers } from '../../utils/removableMarkers'

/**
 * Welche Eigenschaften trägt die AUSWAHL — nicht die einzelne Aufgabe.
 *
 * Das **Aufgaben-Menü** meint die ganze Auswahl (CONTEXT.md), und sein Haken
 * sagt „das ist gesetzt". Bei mehreren Aufgaben darf er deshalb nur stehen,
 * wenn ALLE ihn verdienen: Ein Haken bei drei Aufgaben, von denen eine kein
 * Datum hat, wäre schlicht falsch.
 *
 * Bewusst ohne React-Bezug — gerechnet wird hier, gemessen nirgends.
 */

/**
 * Absichtlich STRUKTURELL und nicht `Task` oder `TaskEntryData`: Gefragt ist
 * nur, ob sechs Felder belegt sind, und die tragen beide Modelle — in leicht
 * verschiedenen Typen. Wer hier ein Modell festschriebe, zwänge jede Seite zu
 * einer Umrechnung, die nichts umrechnet.
 */
export interface TaskMenuMarkSource {
  startDate?: unknown
  rewardId?: unknown
  estimatedDuration?: unknown
  dueDate?: unknown
  attention?: unknown
  tags?: readonly unknown[] | null
  recurrence?: unknown
  /** Favorit (#210): am Modell `favoriteOrder`, an der Zeile `favorite`. */
  favoriteOrder?: unknown
  favorite?: boolean
}

export interface TaskMenuMarks {
  start: boolean
  duration: boolean
  deadline: boolean
  recurrence: boolean
  attention: boolean
  tags: boolean
  /** ALLE sind Favoriten — dann heißt die Zeile „Aus Favoriten entfernen“ (#210). */
  favorite: boolean
  /**
   * Wo es etwas zu **entfernen** gibt — anders als der Haken, sobald IRGENDEINE der Aufgaben die Marke trägt:
   * Das Menü schreibt auf alle (#313). Fehlt es, entscheidet die angeklickte Aufgabe.
   */
  removable?: RemovableMarkers
}

const EMPTY: TaskMenuMarks = {
  start: false,
  duration: false,
  deadline: false,
  recurrence: false,
  attention: false,
  tags: false,
  favorite: false,
}

/**
 * `tasks` ist leer, wenn nichts ausgewählt ist — dann gibt es auch nichts
 * anzukreuzen. Der Aufrufer reicht in dem Fall die angeklickte Aufgabe allein
 * herein.
 */
export function taskMenuMarks(tasks: readonly TaskMenuMarkSource[]): TaskMenuMarks {
  if (tasks.length === 0) return EMPTY
  return {
    start: tasks.every(task => task.startDate != null),
    duration: tasks.every(task => task.estimatedDuration != null),
    deadline: tasks.every(task => task.dueDate != null),
    recurrence: tasks.every(task => task.recurrence != null),
    attention: tasks.every(task => task.attention != null),
    tags: tasks.every(task => (task.tags?.length ?? 0) > 0),
    favorite: tasks.every(task => task.favoriteOrder != null || task.favorite === true),
    removable: removableMarkers(tasks),
  }
}
